export function numbersOnly(value: string) {
    return value.replace(/\D/g,'');
}